import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const glutter = 30;

const WrapperWrapper = styled.div`
  max-width: 1024px;
  padding: 0 ${glutter / 2}px;
  margin: 0 auto;
  box-sizing: border-box;
  
  * {
    box-sizing: border-box;
  }
`;

const RowWrapper = styled.div`
  display: flex;
  margin-left: -${glutter / 2}px;
  margin-right: -${glutter / 2}px;
  
  @media (max-width: 850px) {
    display: block !important;
    > div {
      width: 100% !important;
    }
  }
`;

const ColWrapper = styled.div`
  padding: 0 ${glutter / 2}px;
  
  &.one-fourth { width: 25%; }
  &.three-fourths { width: 75%; }
  
  &.one-half { width: 50%; }
  
  &.one-third { width: 33.3%; }
  &.two-thirds { width: 66.6%; }
`;

const Wrapper = props => {
    return (
        <WrapperWrapper>
            {props.children}
        </WrapperWrapper>
    );
};

Wrapper.propTypes = {
    class: PropTypes.string
};

const Row = props => {
    return (
        <RowWrapper className={props.class}>
            {props.children}
        </RowWrapper>
    );
};

Row.propTypes = {
    class: PropTypes.string
};

const Col = props => {
    return (
        <ColWrapper className={props.class}>
            {props.children}
        </ColWrapper>
    );
};

Col.propTypes = {
    class: PropTypes.string
};

export default {
    Wrapper,
    Row,
    Col
};
